import { els, breakpoints } from './variables';

function initScrollJs() {
    const el = els.html;
    el.classList.add('not-scrolling');
    window.addEventListener('scroll', function() {
        el.classList.remove('not-scrolling');
        clearTimeout(timer);
        const timer = setTimeout(function() {
            el.classList.add('not-scrolling');
        }, 300);
    });
}

window.addEventListener('DOMContentLoaded', initScrollJs);